import React from 'react';
import ReactDOM from 'react-dom/client';

// Order matters: tokens define the variables that app.css consumes.
import './styles/tokens.css';
import './styles/app.css';

import { LangProvider } from './i18n.js';
import App from './app.jsx';

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <LangProvider initial={document.documentElement.lang || 'en'}>
      <App />
    </LangProvider>
  </React.StrictMode>,
);
